export default __webpack_public_path__ + "static/char-s-29-ko-ced50ff8a52ecfe7b0a2e3a82b45feb7.webp";